module.exports = __webpack_public_path__ + "img/文字版.8466ad34.jpg";